/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface MarketplaceCatalog {
  id?: number;
  header?: string;
  category_name: string;
  type_name: string;
  description_category_id: number;
  children: MarketplaceCatalog[];
  lastLevel?: boolean;
  disabled?: boolean;
  checked?: boolean;
  typeId?: number;
  type_id?: number;
  parentID?: number;  // wb
  parentName?: string;  // wb
  subjectID?: number;  // wb
  subjectName?: string;  // wb
}
